import { useLocation } from 'react-router-dom';
import { useEffect, useReducer, useState, useContext } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import Carousel from '../components/Carousel';
import { Store } from '../Store';
import { loginCallback, publicApiUrl } from '../config';
import { checkAuth } from '../utils';
import FeaturedProducts from '../components/FeaturedProducts';
import { Col, Container, Row } from 'react-bootstrap';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, products: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const HomeScreen = () => {
  const [{ loading, error, products }, dispatch] = useReducer(reducer, {
    products: [],
    loading: true,
    error: '',
  });
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const urlPath = useLocation();

  // useEffect(() => {
  //   checkAuth({
  //     urlPath,
  //     userInfo,
  //     ctxDispatch,
  //     toast,
  //     callbackUrl: loginCallback,
  //     shouldRedirect: false,
  //   });
  // }, []);
  // const [products, setProducts] = useState([]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     dispatch({ type: 'FETCH_REQUEST' });
  //     try {
  //       const result = await axios.get(`${publicApiUrl}/products`);
  //       dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
  //     } catch (err) {
  //       dispatch({ type: 'FETCH_FAIL', payload: err.message });
  //     }

  //     // setProducts(result.data);
  //   };
  //   fetchData();
  // }, []);
  return (
    <div>
      <Helmet>
        <title>Project Dream</title>
      </Helmet>
      <div className="m-0">
        <hr />
        <div className="d-flex justify-content-center">
          <h1 className="d-block">DREAM TO <span style={{color:"salmon"}}>HELP</span></h1>
        </div>
        <div className="d-flex justify-content-center text-center">
          <p style={{width: "650px"}}>
            <span style={{color:"salmon"}}>Project</span> Dream is a platform that carries the concept of caring for fellow human beings. Philippines is a third world country.  Many people are struggling to get by because of the inequality of wealth.  Some don't have food and some lack the opportunity to get an education. Through Project Dream, you can donate through us and help someone in need.
          </p>
        </div>

          <div style={{overflow: 'hidden', paddingBottom: '56.25%', position: 'relative', height: '0'}} className="embed-responsive embed-responsive-16by9">
          <iframe width="853" height="480" style={{left: 0, top: 0, height: '100%', width: '100%', position: 'absolute'}} src="https://www.youtube.com/embed/fK2K4VGnz50" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>

        <section className="page-section my-5 py-5" id="mission">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">Mission</h2>
                    <h3 className="section-subheading text-muted">Project <span style={{color:"salmon"}}>Dream</span> is dedicated to provide help to the ones that are in need.</h3>
                </div>
                <div className="row text-center">
                    <div className="col-md-4">
                        <span className="fa-stack fa-4x">
                            <i className="fas fa-circle fa-stack-2x" style={{color: "salmon"}}></i>
                            <i className="fas fa-bowl-food fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="my-3">Food</h4>
                        <p className="text-muted">Hunger is everywhere especially in the Philippines, kids walking and begging for money to buy food. For $2, you can buy someone a full meal. Donate to buy food for someone in need.</p>
                    </div>
                    <div className="col-md-4">
                        <span className="fa-stack fa-4x">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className="fas fa-book fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="my-3">School Supplies</h4>
                        <p className="text-muted">Unfortunately, students lack school supplies just because they don't have enough money. For $20, you can buy a full supplies. Donate to buy school supplies for someone in need.</p>
                    </div>

                    <div className="col-md-4">
                        <span className="fa-stack fa-4x">
                            <i className="fas fa-circle fa-stack-2x" style={{color: "salmon"}}></i>
                            <i className="fas fa-school fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="my-3">Education</h4>
                        <p className="text-muted">Education is important for anyone's success. For about $300, you can pay for someone's education for one semester. Donate to give someone an opportunity to go to school.</p>
                    </div>
                </div>
            </div>
        </section>
        <hr />
        <section className="page-section my-5 py-5" id="vision">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase"><span style={{color:"salmon"}}>Vision</span></h2>
                    <h3 className="section-subheading text-muted">
                    Project <span style={{color:"salmon"}}>Dream</span>'s vision is to touch the lives of Filipinos who are in need and spread awareness to the people who has the means to help. It is our duty to help our fellow Filipinos to rise from poverty. </h3>
                </div>
            </div>
        </section>
        <hr />
        <section className="page-section my-5 py-5" id="about">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">About <span style={{color:"salmon"}}>Us</span></h2>
                    <h3 className="section-subheading text-muted">Just your average good samaritans who wants to do good one place at a time.</h3>
                </div>
            </div>
        </section>
        <section className="page-section">
          <Container>
            <Row className="my-5">
              <Col md={6} className="text-center">
                <img style={{height: "300px"}} className="rounded img-fluid" src="images/giving.jpg"/>
                <h4 className="my-3">Priceless Smile</h4>
                <div style={{fontSize: "20px"}}><p class="text-muted">
                  Putting a smile on anyone is priceless. Hardships or not, they always manage to find happiness as long as they have each other.
                </p></div>
              </Col>
              <Col md={6} className="text-center">
                <img style={{height: "300px"}} className="rounded img-fluid" src="images/thankyou.jpg"/>
                <h4 className="my-3">They are the future</h4>
                <div style={{fontSize: "20px"}}><p class="text-muted">A little bit of help goes a long way. You don't have to be rich to help someone</p></div>
              </Col>
            </Row>
            <Row className="my-5">

              <Col md={6} className="text-center">

              </Col>
              <Col md={6}>

              </Col>
            </Row>
          </Container>
        </section>
      </div>

      {/* <Carousel /> */}
      {/* <FeaturedProducts title="Featured Product" loading={loading} error={error} products={products} /> */}

    </div>
  );
}
export default HomeScreen;
